var _rect, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg4 = function Svg4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_678_90",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#4DA85C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_678_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.26927 12L1.33594 11.0667L4.86927 7.53333C5.25816 7.14444 5.73038 6.95 6.28594 6.95C6.84149 6.95 7.31371 7.14444 7.7026 7.53333L8.46927 8.3C8.6026 8.43333 8.76094 8.5 8.94427 8.5C9.1276 8.5 9.28594 8.43333 9.41927 8.3L12.3859 5.33333H10.6693V4H14.6693V8H13.3359V6.28333L10.3526 9.25C9.96372 9.63889 9.49149 9.83333 8.93594 9.83333C8.38038 9.83333 7.90816 9.63889 7.51927 9.25L6.73594 8.46667C6.61372 8.34444 6.45816 8.28333 6.26927 8.28333C6.08038 8.28333 5.92483 8.34444 5.8026 8.46667L2.26927 12Z",
    fill: "#4DA85C"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4.f4933009.svg";
export { ForwardRef as ReactComponent };